/* tslint:disable */
/* eslint-disable */
/**
 * TRWL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { Product } from './product';
// May contain unused imports in some cases
// @ts-ignore
import type { Variant } from './variant';

/**
 * 
 * @export
 * @interface CartItemResponse
 */
export interface CartItemResponse {
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'variantId': number;
    /**
     * 
     * @type {string}
     * @memberof CartItemResponse
     */
    'deliveryType': CartItemResponseDeliveryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CartItemResponse
     */
    'count': number;
    /**
     * 
     * @type {Variant}
     * @memberof CartItemResponse
     */
    'variant'?: Variant;
    /**
     * 
     * @type {Product}
     * @memberof CartItemResponse
     */
    'product'?: Product;
    /**
     * 
     * @type {boolean}
     * @memberof CartItemResponse
     */
    'available'?: boolean;
}

export const CartItemResponseDeliveryTypeEnum = {
    Default: 'DEFAULT',
    Airplane: 'AIRPLANE'
} as const;

export type CartItemResponseDeliveryTypeEnum = typeof CartItemResponseDeliveryTypeEnum[keyof typeof CartItemResponseDeliveryTypeEnum];


